module.exports = __webpack_public_path__ + "img/oneHundred.93743741.svg";